import {filter} from "lodash"

import authentication from "@irati/auth"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import usersToString from "./usersToString"

export const pollUsersToStringTitle = (receivers, formatMessage) => {
  if (receivers.length === 0) {
    return formatMessage({id: "recognition.popup.viewPoll.empty"})
  }

  const you = filter(receivers, (test) => test.uuid === authentication.user().uuid)[0]

  if (you) {
    const others = filter(receivers, (test) => test.uuid !== authentication.user().uuid)
    return usersToString(you, others, formatMessage)
  }
  if (receivers) {
    if (receivers.length === 1) {
      return formatMessage({id: "recognition.utils.pollUsersToString.oneVoted.title"}, {pollWinnerName: firstnameLastname(receivers[0])})
    }
    if (receivers.length === 2) {
      return formatMessage(
        {id: "recognition.utils.pollUsersToString.twoVoted.title"},
        {pollWinnerNameOne: firstnameLastname(receivers[0]), pollWinnerNameTwo: firstnameLastname(receivers[1])}
      )
    }
    if (receivers.length === 3) {
      return formatMessage(
        {id: "recognition.utils.pollUsersToString.threeVoted.title"},
        {
          pollWinnerNameOne: firstnameLastname(receivers[0]),
          pollWinnerNameTwo: firstnameLastname(receivers[1]),
          pollWinnerNameThree: firstnameLastname(receivers[2])
        }
      )
    }
    if (receivers.length > 3) {
      return formatMessage({id: "recognition.utils.usersToString.fourOrMore.title"}, {nbOfUsers: receivers.length})
    }
  }
}

export const pollUsersToStringSubtitle = (receivers, pollName, formatMessage) => {
  const you = filter(receivers, (test) => test.uuid === authentication.user().uuid)[0]
  const others = filter(receivers, (test) => test.uuid !== authentication.user().uuid)

  if (you) {
    if (others.length === 0) {
      return formatMessage({id: "recognition.utils.pollUsersToString.youSingleVoted.subtitle"}, {pollName})
    }
    return formatMessage({id: "recognition.utils.pollUsersToString.youMultipleVoted.subtitle"}, {pollName})
  }

  if (receivers.length === 1) {
    return formatMessage({id: "recognition.utils.pollUsersToString.otherSingleVoted.subtitle"}, {pollName})
  }

  return formatMessage({id: "recognition.utils.pollUsersToString.otherMultipleVoted.subtitle"}, {pollName})
}
